import { graphql } from "msw";
import {
  mockCart,
  mockUserCoupon,
  mockCouponMetadata,
  mockCartOrderSummary,
} from "./mockCart";
import {
  UpdateCartCouponMutationVariables,
  UpdateCartCouponMutation,
} from "@cart-app/generated/graphql";
import { UNAUTHORISED_USER_COUPON_CODE } from "@cart-app/mocks/constants";

const newMockUserCoupon = {
  ...mockUserCoupon,
  coupon: {
    ...mockCouponMetadata,
    code: "GET15FREE",
  },
};

const mockDiscount = {
  discount: {
    amount: 1500,
    currency: "AUD",
  },
  deletable: true,
  type: "MANUAL",
  label: newMockUserCoupon.coupon.code,
};

export const handler = graphql.mutation<
  UpdateCartCouponMutation,
  UpdateCartCouponMutationVariables
>("UpdateCartCoupon", (req, res, ctx) => {
  const { code } = req.variables;

  if (!code) {
    return res(
      ctx.errors([
        {
          message: "Coupon code not provided.",
        },
      ])
    );
  }

  if (code == UNAUTHORISED_USER_COUPON_CODE) {
    return res(
      ctx.data({
        updateCartCoupon: {
          __typename: "UnauthorisedUserError" as const,
          messageOverride: {
            template:
              "You must be logged in to use this coupon. {{ login_link }}",
            placeholders: [
              {
                id: "login_link",
                text: "Click here to log in",
                url: "https://www.catch.com.au/login",
              },
            ],
            default: "Something went wrong",
          },
        },
      })
    );
  }

  if (code !== newMockUserCoupon.coupon.code) {
    return res(
      ctx.data({
        updateCartCoupon: {
          __typename: "UserError" as const,
          message: "Coupon code is invalid. Please try again.",
        },
      })
    );
  }

  const cartTotal =
    (mockCartOrderSummary.giftCards || [])?.reduce(
      (acc, giftCard) => (acc -= giftCard.appliedBalance.amount),
      mockCartOrderSummary.subtotalPrice.amount
    ) - mockDiscount.discount.amount;

  return res(
    ctx.data({
      updateCartCoupon: {
        __typename: "Cart" as const,
        ...mockCart,
        userCoupon: newMockUserCoupon,
        orderSummary: {
          ...mockCartOrderSummary,
          discounts: [mockDiscount],
          storeCredit: {
            applied: {
              amount: 500,
              currency: "AUD",
            },
            remaining: {
              amount: 1000,
              currency: "AUD",
            },
          },
          giftCards: [
            {
              code: "502904200000456102",
              isOnePassReward: false,
              appliedBalance: {
                amount: 1200,
              },
              remainingBalance: {
                amount: 5500,
              },
            },
          ],
          totalPrice: {
            __typename: "Money" as const,
            amount: cartTotal,
          },
        },
      },
    })
  );
});
